import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { atomEffect } from 'jotai-effect';
import { localForageStore } from '../../store/localForageStore';
import { IMessageReportCreated } from '../SocketConnection/types';

export interface IDownloadLater {
  code: string;
  jobId: string;
}

export interface IDownload {
  jobId: string;
  isDownloaded: boolean;
  code: string;
  percentage: number;
  filename: string;
  generating_start: string;
  generating_end: string | null;
}

export const isActiveAtom = atom<false | string>(false);

export const dataAtom = atom<IMessageReportCreated | null>(null);

export const valuesJsonsAtom = atom<string[]>([]);

export const downloadsAtom = atomWithDefault<IDownload[]>(() =>
  localForageStore.getItem<IDownload[] | null>('exportDownloads').then((v) => v ?? [])
);

export const exportDownloadsEffectAtom = atomEffect((get) => {
  const value = get(downloadsAtom);
  if (value instanceof Promise) {
    value.then((v) => localForageStore.setItem('exportDownloads', v));
    return;
  }
  localForageStore.setItem('exportDownloads', value);
});
